import { render, staticRenderFns } from "./planSelect.vue?vue&type=template&id=71fda89b"
import script from "./planSelect.vue?vue&type=script&lang=js"
export * from "./planSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports